import { render, staticRenderFns } from "./ModalCadastroHabilidade.vue?vue&type=template&id=2f3ef476"
import script from "./ModalCadastroHabilidade.vue?vue&type=script&lang=js"
export * from "./ModalCadastroHabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports